<script setup>
import Accordion from "@/components/ui/accordion/Accordion.vue";
import AccordionContent from "@/components/ui/accordion/AccordionContent.vue";
import AccordionItem from "@/components/ui/accordion/AccordionItem.vue";
import AccordionTrigger from "@/components/ui/accordion/AccordionTrigger.vue";
import Item from "@/components/ui/item/Item.vue";
import ItemContent from "@/components/ui/item/ItemContent.vue";
import Toggle from "@/components/ui/toggle/Toggle.vue";
import { CheckIcon, Search } from "lucide-vue-next";
import { ref } from "vue";
import ItemMedia from "./ui/item/ItemMedia.vue";
import ItemTitle from "./ui/item/ItemTitle.vue";
import ItemDescription from "./ui/item/ItemDescription.vue";

const emit = defineEmits(["toggleInterest"]);

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  imageURL: {
    type: String,
    required: true,
  },
  isInterested: {
    type: Boolean,
    required: true,
  },
  countInterested: {
    type: Number,
    default: 0,
  },
  interestedProfiles: {
    type: Array,
    default: [],
  },
});
</script>

<template>
  <Item
    variant="outline"
    class="h-min-16 grow hover:bg-accent/50 flex items-start gap-3 rounded-lg border p-3"
    :class="{
      'border-primary bg-primary/50 dark:border-primary/50 dark:bg-primary/20':
        props.isInterested,
      'hover:bg-primary/10': props.isInterested,
    }"
    id="toggle-3"
  >
    <ItemContent>
      <Accordion type="single" collapsible default-value="" class="w-full">
        <AccordionItem value="item-1">
          <AccordionTrigger class="flex flex-row items-center py-0">
            <img
              :src="props.imageURL"
              alt="Game Image"
              class="w-15 h-15 object-cover rounded"
            />
            <div class="grow">{{ props.name }}</div>
            <div class="text-muted-foreground">
              {{ props.countInterested }} want to play
            </div>
          </AccordionTrigger>
          <AccordionContent class="w-full min-w-fit mt-3">
            <div class="mt-2">
              <div class="text-xl font-semibold mb-2">Interested Users</div>
              <Item
                variant="outline"
                v-for="profile in props.interestedProfiles"
                class="flex flex-row mb-2"
              >
                <ItemMedia class="h-16 w-16 radius-md">
                  <img :src="profile.avatarUrl" alt="" /> </ItemMedia
                ><ItemContent>
                  <ItemTitle>{{ profile.nickname }} </ItemTitle>
                  <ItemDescription
                    ><a
                      :href="`https://steamcommunity.com/profiles/${profile.id}/`"
                      >View their profile</a
                    ></ItemDescription
                  ></ItemContent
                ></Item
              >
            </div>
            <Toggle
              :key="props.isInterested"
              id="toggle-3"
              variant="outline"
              :class="[
                'w-full mt-4 cursor-pointer',
                {
                  'bg-primary': props.isInterested,
                  'hover:bg-primary/70': props.isInterested,
                },
              ]"
              @click="emit('toggleInterest', $event)"
            >
              <CheckIcon></CheckIcon>Interested</Toggle
            >
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </ItemContent>
  </Item>
</template>
